import React from 'react';
import { Route, Switch } from 'react-router-dom';

import List from './List';
import View from './View';

export const CommitteeSessions = () => {
	const rootPath = '/admin';
	return <Switch>
			<Route exact path={`/admin/committeesessions/`} component={() => <List rootPath={rootPath} />} />
			<Route exact path={`/admin/committeesessions/:id`} component={() => <View rootPath={rootPath} />} />
	</Switch>;
};
